import { CellContext } from '@tanstack/react-table';
import React from 'react';
import { SetupIpaStoresAndClustersRowData } from '../../../service';
import styles from './Cells.module.scss';

export const StoreType = ({ row: { original: rowData } }: CellContext<SetupIpaStoresAndClustersRowData, unknown>) => {
  return <p className={styles['store-type']}>{rowData.storeType}</p>;
};
